<template lang="pug">
  #BackgroundDownload
    .text-center.mb-3
      b-badge
        h5.mb-0 請長按圖片並儲存
    b-img(
      fluid,
      :src="backgroundImg",
      alt="Send Video",
      @click="downloadHandler"
    )
</template>

<script>
import backgroundImgUrl from '@/assets/images/bg/backgroundImg.jpg';

export default {
  name: 'BackgroundDownloadIndex',
  data() {
    return {
      backgroundImg: backgroundImgUrl,
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    downloadHandler() {
      let image = new Image();
      image.src = backgroundImgUrl;
      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        var base64 = canvas.toDataURL();
        var a = document.createElement('a');
        a.href = base64;
        a.download = '';
        a.click()
			};
      image.setAttribute('crossOrigin', 'Anonymous');
    },
  }
};
</script>

<style>

</style>
